import { render, staticRenderFns } from "./SupportItem.vue?vue&type=template&id=2e0b6eca&scoped=true"
import script from "./SupportItem.vue?vue&type=script&lang=js"
export * from "./SupportItem.vue?vue&type=script&lang=js"
import style0 from "./SupportItem.vue?vue&type=style&index=0&id=2e0b6eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b6eca",
  null
  
)

export default component.exports